import './App.css';
import { useState } from 'react';
import Axios from 'axios';

function App() {
  const [bookChosen, setBookChosen] = useState(false);
  const [book, setBook] = useState({
    city: "",
    img: "",
    img2: "",
    img3: "",
    country: "",
    year: "",
    summary: "",
    text: "",
    map: "",
    url: ""
  });


  const randomMiracle = () => {
    const min = Math.ceil(1)
    const max = Math.floor(144)
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  const searchBook = () => {

    // Reads the API
    Axios.get('https://api.npoint.io/3e4bad5cae424305eec1/miracles/' + randomMiracle())
    .then((response) => {
      console.log(response);
      setBook({
        city: response.data.city,
        img: response.data.img,
        img2: response.data.img2,
        img3: response.data.img3,
        country: response.data.country,
        year: response.data.year,
        summary: response.data.summary,
        text: response.data.text,
        map: response.data.map,
        url: response.data.url
      });
      addNewLines(book);
      setBookChosen(true);
    });

  };

  // Adds a new line after "."
  const addNewLines = (book) => {
    book.summary = book.summary.replaceAll(/\. /g, '.\n');
    book.text = book.text.replaceAll(/\. /g, '.\n');
  };

  return (
    <div className="App">
      <div className="TitleSection">
        <h1>miracle of the day.org</h1>

        <button onClick={searchBook}>Miracle Guide</button>
      </div>
      <div className="DisplaySection">
        {!bookChosen ?
        (<h3> Click the button to get your miracle of the day </h3>)
        :
        (
        <>
        <h2>{book.city}, {book.country}, {book.year}</h2>
        <h3><a target="_blank" rel="noreferrer" href={book.map}>Map</a></h3>

        <div className="card" >
          <img src={book.img} style={{alignItems: "center"}}/>
          <img src={book.img2} style={{alignItems: "center"}}/>
          <img src={book.img3} style={{alignItems: "center"}}/>
        </div>


        <div className="lineBreak">
          <div className="card">
            <h6>{book.summary}</h6>
            <h6>{book.text}</h6>
          </div>
        </div>

        <h4><a target="_blank" rel="noreferrer" href={book.url}>Visit the original exhibition of Carlo Acutis</a></h4>
        <h4><a target="_blank" rel="noreferrer" href="https://www.amazon.com/Eucharist-Mystery-Presence-Sacrifice-Communion/dp/1945125721/ref=sr_1_2?dchild=1&amp;keywords=eucharist&amp;qid=1610h493073&amp;sr=8-2/&amp;WZoneDirect-no-more-redirect&_encoding=UTF8&tag=nelsonsc-20&linkCode=ur2&linkId=2209460d7022c9540d4de247a7ea7c15&camp=1789&creative=9325">Learn more about The Eucharist</a></h4>
        <h4><a target="_blank" rel="noreferrer" href="http://www.saintsquotes.org">Visit our sister website SaintsQuotes.org</a></h4>
      <h4><a target="_blank" rel="noreferrer" href="http://www.biblepassage.org">Visit our sister website BiblePassage.org</a></h4>
        </>
        )}

      </div>
    </div>
  );
}

export default App;
